<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('form_label_search') ||
                  'TC采购请款单编号/业务人员/供应商/付款方 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="
                openEditPage({
                  pageType: 'add',
                  params: {},
                })
              "
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1100px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="160px" size="small">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_tcExpenseStatus') || '采购请款单状态'"
            >
              <dict-select
                v-model="form.tcExpenseStatusList"
                url="/sys/common/dict/system"
                :body="tcExpenseStatusParams"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                clearable
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_tcExpenseNo') || '采购请款单编号'"
            >
              <el-input
                v-model.trim="form.tcExpenseNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="
                $l('INDEX.order_form_label_salesPersonCode') || '业务人员'
              "
            >
              <dict-select
                v-model="form.salesPersonCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                clearable
                filterable
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_payeeScm') || '收款供应商'">
              <dict-select
                v-model="form.payeeScmCode"
                url="/master/common/dict/scmPartners"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                clearable
                filterable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_tcRequestType') || 'TC请款类型'"
            >
              <dict-select
                v-model="form.tcRequestTypeList"
                :body="tcRequestTypeParams"
                url="/master/common/dict/biz"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                clearable
                filterable
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_expensePayer') || '付款公司'">
              <dict-select
                v-model="form.expensePayerCode"
                :body="expensePayerParams"
                url="/master/common/dict/biz"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_paymentMethod') || '付款方式'">
              <dict-select
                v-model="form.paymentMethodList"
                :body="paymentMethodParams"
                url="/master/common/dict/biz"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                clearable
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.table_label_bank_name') || '开户银行'"
            >
              <el-input
                v-model.trim="form.bankName"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
                maxlength="100"
                show-word-limit
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.table_label_bank_account_name') || '账户名称'"
            >
              <el-input
                v-model.trim="form.bankAccountName"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
                maxlength="100"
                show-word-limit
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.table_label_bank_account_no') || '银行账号'"
            >
              <el-input
                v-model.trim="form.bankAccountNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
                maxlength="50"
                show-word-limit
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.table_label_bank_account_type') || '账户性质'"
            >
              <el-select
                size="small"
                v-model="form.bankAccountType"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                style="width: 100%"
                filterable
                clearable
              >
                <el-option
                  v-for="item in bankAccountOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.table_label_bank_account_kind') || '账号类别'"
              prop="bankAccountKind"
            >
              <dict-select
                size="small"
                clearable
                filterable
                v-model="form.bankAccountKind"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                :body="bankAccountKindParams"
                url="/master/common/dict/biz"
              ></dict-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_currencyUnit') || '货币单位'"
              prop="currencyUnit"
            >
              <dict-select
                v-model="form.currencyUnitList"
                :body="bankAccountKindParams"
                url="/master/common/dict/biz"
                size="small"
                clearable
                filterable
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-row>
              <el-form-item :label="$l('form_label_requestDate') || '申请日期'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginRequestDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="requestDateStartPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endRequestDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="requestDateEndPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('form_label_estimatedPaymentDate') || '预计付款日期'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginEstimatedPaymentDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="estimatedPaymentDateStartPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endEstimatedPaymentDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="estimatedPaymentDateEndPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-row>
              <el-form-item :label="$l('INDEX.create_date') || '创建时间'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginCreateTime"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="beginCreateTimePicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endCreateTime"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="endCreateTimePicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('INDEX.form_label_modification_time') || '修改时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginModifyTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="modifyTimeStartPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endModifyTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="modifyTimeEndPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  tcExpenseStatusList: ['N', 'S', 'R', 'Y'],
}
export default {
  data() {
    return {
      tcExpenseStatusParams: { dictType: 'tcExpenseStatus' },
      paymentMethodParams: { dictType: 'paymentMethod' },
      expensePayerParams: { dictType: 'expensePayer' },
      advqueryDialogVisible: false,
      form: { ...initForm },
      bankAccountKindParams: { dictType: 'bankAccountKind' },
      tcRequestTypeParams: { dictType: 'tcRequestType' },
      bankAccountOptions: [
        {
          label: this.$l('INDEX.form_label_company') || '公司',
          value: '0',
        },
        {
          label: this.$l('INDEX.form_label_personal') || '个人',
          value: '1',
        },
      ],
      //申请日期限制
      requestDateStartPicker: this.requestDateEnd(),
      requestDateEndPicker: this.requestDateStart(),
      //预计付款日期限制
      estimatedPaymentDateStartPicker: this.estimatedPaymentDateEnd(),
      estimatedPaymentDateEndPicker: this.estimatedPaymentDateStart(),

      //创建日期限制
      beginCreateTimePicker: this.endCreateTime(),
      endCreateTimePicker: this.beginCreateTime(),
      //修改日期限制
      modifyTimeStartPicker: this.modifyTimeEnd(),
      modifyTimeEndPicker: this.modifyTimeStart(),
    }
  },

  mounted() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },

    openEditPage({ pageType, params = {} }) {
      this.$router.push({
        name: 'tc-expense-detail',
        params: { ...params, pageType },
      })
    },
    // 创建日期限制
    endCreateTime() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.endCreateTime) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.endCreateTime).getTime() < time.getTime()
          }
        },
      }
    },
    beginCreateTime() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.beginCreateTime) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.beginCreateTime).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    // 修改时间限制
    modifyTimeEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.endModifyTime) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.endModifyTime).getTime() < time.getTime()
          }
        },
      }
    },
    modifyTimeStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.beginModifyTime) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.beginModifyTime).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    // 提交时间限制
    requestDateEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.endRequestDate) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.endRequestDate).getTime() < time.getTime()
          }
        },
      }
    },
    requestDateStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.beginRequestDate) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.beginRequestDate).getTime() -
                3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    // 预计付款日期限制
    estimatedPaymentDateEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.endEstimatedPaymentDate) {
            //如果结束时间不为空，则小于结束时间
            return (
              new Date(self.form.endEstimatedPaymentDate).getTime() <
              time.getTime()
            )
          }
        },
      }
    },
    estimatedPaymentDateStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.beginEstimatedPaymentDate) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.beginEstimatedPaymentDate).getTime() -
                3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
